import { format } from "date-fns";
import { cn } from "../../../lib/utils";
import styles from "./ProviderMessageBubble.module.css";

interface ProviderMessageBubbleProps {
	id: string;
	content: string;
	senderName: string;
	senderType: "patient" | "provider";
	createdAt: Date;
	isOwn: boolean;
	status?: "sent" | "delivered" | "read";
}

export function ProviderMessageBubble({
	content,
	senderName,
	createdAt,
	isOwn,
	status = "sent",
}: ProviderMessageBubbleProps) {
	return (
		<div className={cn(styles.container, isOwn && styles.own)}>
			{/* Sender name and timestamp */}
			<div className={cn(styles.header, isOwn && styles.headerOwn)}>
				{!isOwn && <span className={styles.senderName}>{senderName}</span>}
				<span className={cn(styles.timestamp, !isOwn && styles.timestampOther)}>
					{format(createdAt, "HH:mm")}
				</span>
			</div>

			{/* Message bubble */}
			<div
				className={cn(
					styles.bubble,
					isOwn ? styles.bubbleOwn : styles.bubbleOther,
				)}
			>
				<p className={styles.content}>{content}</p>
			</div>

			{/* Message status for own messages */}
			{isOwn && (
				<div className={styles.status}>
					{status === "sent" && "✓"}
					{status === "delivered" && "✓✓"}
					{status === "read" && <span className={styles.statusRead}>✓✓</span>}
				</div>
			)}
		</div>
	);
}
